import { Outlet, useLocation } from 'react-router-dom';
import { useEffect } from 'react';
import { Header } from '@/components/layout/Header';
import { Footer } from '@/components/layout/Footer';
import { FloatingActions } from '@/components/ui/FloatingActions';
import { CookieConsent } from '@/components/ui/CookieConsent';
import { AosController } from '@/lib/aos';
import { initConsentDefaults, trackPageview } from '@/lib/analytics';

// Set up the GA Consent Mode v2 defaults exactly once (module-level), before
// any analytics call. This runs in the browser only - main.tsx already guards
// against SSR for this entire tree.
if (typeof window !== 'undefined') {
  initConsentDefaults();
}

export default function App() {
  const location = useLocation();
  useEffect(() => {
    if (typeof window !== 'undefined') window.scrollTo(0, 0);
    trackPageview(location.pathname);
  }, [location.pathname]);

  return (
    <div className="flex min-h-screen flex-col">
      <AosController />
      <Header />
      <main className="flex-1">
        <Outlet />
      </main>
      <Footer />
      <FloatingActions />
      <CookieConsent />
    </div>
  );
}
